import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { AiOutlinePlus, AiOutlineSearch } from "react-icons/ai";
import { FiSidebar } from "react-icons/fi";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "underscore";
import { socket, startSocketService } from "../../helpers/socketHelper";
import {
    getRandomColor,
    IsNullOrEmpty,
    URLReplacer,
} from "../../helpers/utility";
import NotificationAPI from "../../store/notification/notification.api";
import { getCartProductList } from "../../store/shopping/shopping.selector";
import {
    fetchEventRequest,
    fetchLiveStreamRequest,
    fetchReactionRequest,
    updateEventInternal,
} from "../../store/social/social.actions";
import {
    getEvents,
    getLiveStreams,
    getReactions,
} from "../../store/social/social.selector";
import {
    fetchOtherUserProfileRequest,
    followUserRequest,
} from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";

const Chat = () => {
    const dispatch = useDispatch();
    const [openSidebar, setOpenSidebar] = useState(false);
    const location = useLocation();
    const [userId, setUserId] = useState("");
    const [joinedGuests, setJoinedGuests] = useState([]);
    const [searchText, setSearchText] = useState("");
    const history = useNavigate();
    const { users, userProfile, reactions, comments } = useSelector((state) => {
        return {
            products: getCartProductList(state),
            userProfile: getUserProfile(state),
            userProfile: getUserProfile(state),
            comments: getEvents(state),
            reactions: getReactions(state),
            livestreams: getLiveStreams(state),
            users: getSearchedUsers(state),
        };
    });

    useEffect(() => {
        let uid = location && location.state && location.state.userId;
        if (uid) {
            setUserId(uid);
        } else {
            setUserId(userProfile._id);
        }
    }, [location]);

    useEffect(() => {
        if (reactions.length === 0 || !socket) {
            startSocketService();
        }
        dispatch(fetchReactionRequest());
        socket.on("sendCommentMessage", (data) => {
            let req = data.data;
            req.infoUser = data.infoUser;
            req.dateCreated = moment().format();
            req.dateUpdated = moment().format();
            dispatch(updateEventInternal(req));
        });

        socket.on("sendReactioMessage", (data) => {
            let req = data.data;
            req.infoUser = data.infoUser;
            req.dateCreated = moment().format();
            req.dateUpdated = moment().format();
            dispatch(updateEventInternal(req));
        });

        socket.on("listAudienceMessage", (data) => {
            console.log("listAudienceMessage");
            setJoinedGuests(data.listAudience);
        });
    }, []);

    useEffect(() => {
        if (!IsNullOrEmpty(userId)) {
            dispatch(fetchLiveStreamRequest("?where=owner:" + userId));
            dispatch(
                fetchEventRequest("?where=livestream:" + userId + "&chat=yes")
            );
            handleJoin();
        }
    }, [userId]);

    const handleJoin = () => {
        if (socket) {
            socket.emit("joinLive", {
                room: userId,
                type: userId === userProfile._id ? "host" : "guests",
                infoUser: userProfile,
                disable: true,
            });

            socket.on("joinLiveMessage", (data) => {
                setJoinedGuests([...joinedGuests, data.infoUser]);
            });
        }
    };

    const sendComment = () => {
        let comment = document.getElementById("sendComment").value;
        if (socket && !IsNullOrEmpty(comment)) {
            socket.emit("sendComment", {
                room: userId,
                dataCreate: {
                    user: userProfile.fullName,
                    timesAppear: 1,
                    livestream: userId,
                    type: "Main",
                    content: comment,
                },
                infoUser: userProfile,
            });
            let data = userProfile;
            data.attachment = userProfile.avatar.attachments;
            let userIds = _.uniq(comments, (person) => person.user)
                .map((x) => x.user)
                .filter((y) => y !== userProfile._id);

            if (userIds.length > 0) {
                NotificationAPI.sendPushNotifications({
                    userIds: userIds,
                    title: "Chatroom",
                    content: userProfile.fullName + " send message in chatroom",
                    type: "chatRoom",
                    data: data,
                });
            }
            document.getElementById("sendComment").value = "";
        }
    };

    //return <p />;
    let participantslist = _.uniq(comments, (person) => person.user);

    let colors = {};

    participantslist.forEach((item, index) => {
        colors[item.infoUser._id] = getRandomColor()[index];
    });

    if (!IsNullOrEmpty(searchText)) {
        participantslist = participantslist.filter((item) => {
            return (
                item.infoUser.fullName
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    const curUser = _.find(users, (x) => x._id === userId);

    if (!curUser) {
        return <p></p>;
    }

    return (
        <div className="p-2 sm:m-4 lg:m-0 lg:px-0 lg:py-0 h-full overflow-hidden">
            <div className="flex relative h-full">
                <div className="flex-1 lg:px-8 lg:py-7 h-full lg:ml-[345px] sm:ml-[0px]">
                    <div className="flex flex-col h-full justify-between bg-white rounded-lg border border-black-10 pb-2.5">
                        <div className="pl-2 sm:pl-4 lg:px-0 flex items-center">
                            <FiSidebar
                                onClick={() => setOpenSidebar(true)}
                                className="text-2xl text-orange-color cursor-pointer lg:hidden"
                            />

                            <div className="px-2 sm:px-4 py-2.5 w-full flex items-center gap-x-2 border-b border-black-10">
                                <img
                                    src={
                                        userId === userProfile._id
                                            ? getImage(
                                                  userProfile.avatar.attachments
                                              )
                                            : getImage(curUser.attachments)
                                    }
                                    alt=""
                                    className="rounded-full w-12 h-12"
                                />
                                <div className="">
                                    <h5 className="text-sm sm:text-base font-bold text-black-color leading-5">
                                        {userId === userProfile._id
                                            ? userProfile.fullName
                                            : curUser.fullName}
                                    </h5>
                                    <p className="text-sm sm:text-sm font-normal text-black-60 m-0">
                                        @
                                        {userId === userProfile._id
                                            ? curUser.account.userName
                                            : curUser.account.userName}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Messages Start Here  */}
                        <div className="flex-grow flex flex-col-reverse space-y-2 overflow-y-auto px-2 sm:px-4 chat-scrollbar-thumb chat-scrollbar-track chat-scrollbar scroll-touch text-black/80 text-base font-medium  scroll-smooth pt-2">
                            {_.unique(comments, (z) => z.code)
                                .sort(
                                    (a, b) =>
                                        moment(a.dateCreated).unix() -
                                        moment(b.dateCreated).unix()
                                )
                                .reverse()
                                .map((x) => {
                                    if (x.infoUser._id !== userProfile._id) {
                                        return (
                                            <div className="chat-message my-4">
                                                <div className="flex items-start justify-start">
                                                    <div className="flex flex-col-reverse space-y-2 text-sm sm:text-sm max-w-[300px] order-2 items-start">
                                                        <div className=" mx-2 text-left">
                                                            <span className="pl-2 sm:pl-3 md:pl-4 pr-3 sm:pr-4 md:pr-5 py-1.5 md:py-2 inline-block rounded-lg rounded-tl-none border-[0.5px] border-black-10 chat-shadow">
                                                                {ReactHtmlParser(
                                                                    URLReplacer(
                                                                        x.content
                                                                    ),
                                                                    true
                                                                )}
                                                            </span>
                                                            <p className="text-[10px] font-medium text-black-60 uppercase opacity-50 mt-0.5 leading-3">
                                                                <time>
                                                                    {moment(
                                                                        x.dateCreated
                                                                    ).fromNow()}
                                                                </time>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <img
                                                        src={
                                                            x.infoUser &&
                                                            x.infoUser.avatar &&
                                                            x.infoUser.avatar
                                                                .attachments
                                                                ? getImage(
                                                                      x.infoUser
                                                                          .avatar
                                                                          .attachments
                                                                  )
                                                                : getImage(
                                                                      x.infoUser
                                                                          .attachments
                                                                  )
                                                        }
                                                        className="rounded-full order-1 w-8 lg:w-10 aspect-square"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div className="chat-message">
                                                <div className="flex items-start justify-end">
                                                    <div className="flex flex-col-reverse text-sm sm:text-sm max-w-[70%] order-1 items-start">
                                                        <div className=" mx-2 text-left">
                                                            <span className="pl-3 sm:pl-2 md:pl-4 pr-3 sm:pr-4 md:pr-5 py-1.5 md:py-2 bg-[#F3E9FD] inline-block rounded-lg rounded-br-none chat-shadow">
                                                                {ReactHtmlParser(
                                                                    URLReplacer(
                                                                        x.content
                                                                    ),
                                                                    true
                                                                )}
                                                            </span>
                                                            <p className="text-[10px] font-medium text-black-60 uppercase opacity-50 mt-0.5 leading-3">
                                                                <time>
                                                                    {moment(
                                                                        x.dateCreated
                                                                    ).fromNow()}
                                                                </time>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <img
                                                        src={
                                                            x.infoUser &&
                                                            x.infoUser.avatar &&
                                                            x.infoUser.avatar
                                                                .attachments
                                                                ? getImage(
                                                                      x.infoUser
                                                                          .avatar
                                                                          .attachments
                                                                  )
                                                                : getImage(
                                                                      x.infoUser
                                                                          .attachments
                                                                  )
                                                        }
                                                        className="rounded-full order-2 w-8 lg:w-10 aspect-square"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                        </div>

                        {/* Message End  */}
                        <div className="px-4 mt-2">
                            <div className="relative">
                                <input
                                    id="sendComment"
                                    type="text"
                                    onKeyPress={(e) => {
                                        if (e.key == "Enter") {
                                            sendComment();
                                        }
                                    }}
                                    className="w-full rounded-full border border-black-10 outline-none py-3 sm:py-[17px] text-black-color pl-2.5 sm:pl-[18px] pr-[160px] sm:pr-48 text-sm sm:text-sm placeholder:text-black-60"
                                    placeholder="Type your message here..."
                                />
                                <div className="flex items-center gap-x-2 sm:gap-x-4 absolute top-2/4 -translate-y-2/4 right-2.5 sm:right-[18px]">
                                    {/* <span className="text-black/50 w-7 h-7 sm:w-8 sm:h-8 flex justify-center items-center border border-black-10 rounded-full cursor-pointer hover:border-orange-color hover:text-orange-color duration-100 ease-linear">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            className="stroke-current"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.87868 10.1213C7.05025 11.2929 8.94975 11.2929 10.1213 10.1213M10.25 6.5H10.2425M5.75 6.5H5.7425M1.25 8C1.25 11.7279 4.27208 14.75 8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25C4.27208 1.25 1.25 4.27208 1.25 8Z"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                    <span className="text-black/50 w-7 h-7 sm:w-8 sm:h-8 flex justify-center items-center border border-black-10 rounded-full cursor-pointer hover:border-orange-color hover:text-orange-color duration-100 ease-linear">
                                        <svg
                                            width="15"
                                            height="16"
                                            viewBox="0 0 15 16"
                                            className="stroke-current"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.37868 4.25L4.43934 9.18934C3.85355 9.77513 3.85355 10.7249 4.43934 11.3107C5.02513 11.8964 5.97488 11.8964 6.56066 11.3107L11.3713 6.37132C12.5429 5.19975 12.5429 3.30025 11.3713 2.12868C10.1997 0.957107 8.30025 0.957107 7.12868 2.12868L2.31802 7.06802C0.56066 8.82538 0.56066 11.6746 2.31802 13.432C4.07538 15.1893 6.92462 15.1893 8.68198 13.432L13.375 8.75"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span> */}
                                    <button
                                        onClick={() => sendComment()}
                                        className="px-1.5 sm:px-[13px] py-1.5 sm:py-[7px] flex items-center text-sm font-bold bg-orange-color text-white rounded-lg"
                                    >
                                        <span className="text-white inline-block mr-2">
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                className="stroke-current"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.75 8L1.25 14.75L14.75 8L1.25 1.25L2.75 8ZM2.75 8L8.75 8"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <span>Send</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className={`${
                        openSidebar
                            ? "translate-x-0 ease-in duration-300 lg:duration-[0ms] lg:transform-none opacity-100"
                            : "-translate-x-full lg:transform-none opacity-0 lg:opacity-100 lg:duration-[0ms] ease-out duration-500"
                    } max-w-[260px] sm:max-w-[345px] absolute top-0 left-0 lg:static w-full h-full bg-white p-4 rounded-tl-lg lg:rounded-none flex justify-between flex-col`}
                >
                    <div className="px-0.5 mb-[18px]">
                        <div className="flex justify-end mb-2 lg:hidden">
                            <button
                                onClick={() => setOpenSidebar(false)}
                                className="p-1 border overflow-visible border-orange-color rounded-full w-fit bg-white cursor-pointer"
                            >
                                <IoIosArrowDown
                                    className={`rotate-90 text-orange-color `}
                                />
                            </button>
                        </div>

                        <div className="relative">
                            <input
                                type="search"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                className="py-[7px] pl-9 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-sm sm:text-sm outline-none"
                                placeholder="Search users"
                            />
                            <AiOutlineSearch className="text-xl absolute top-2/4 -translate-y-2/4 left-[11px] text-black-60 font-bold" />
                        </div>
                    </div>

                    <div className="sidebar flex flex-col justify-between h-full overflow-y-auto">
                        <div className="pb-10">
                            <div className="">
                                <h3 className="text-sm sm:text-sm font-medium text-black-60 mb-2.5 capitalize">
                                    Chatroom participant
                                </h3>
                            </div>
                            <div className="space-y-2.5 ">
                                {joinedGuests
                                    .filter(
                                        (x) =>
                                            (IsNullOrEmpty(searchText) ||
                                                x.fullName
                                                    .toLowerCase()
                                                    .indexOf(
                                                        searchText.toLowerCase()
                                                    ) > -1) &&
                                            userProfile._id !== x._id
                                    )
                                    .map((user) => {
                                        let cur = _.find(
                                            users,
                                            (y) => y._id === user._id
                                        );

                                        return (
                                            <div
                                                key={user._id}
                                                className=" flex items-center justify-between"
                                            >
                                                <div className="flex items-center">
                                                    <img
                                                        src={getImage(
                                                            user.attachments
                                                        )}
                                                        className="rounded-full mr-1.5 w-12 h-12"
                                                        alt=""
                                                        onClick={() => {
                                                            dispatch(
                                                                fetchOtherUserProfileRequest(
                                                                    user._id,
                                                                    history
                                                                )
                                                            );
                                                        }}
                                                    />
                                                    <div className="">
                                                        <h4 className="text-sm font-medium text-black">
                                                            {user.fullName}
                                                        </h4>
                                                        <p className="text-[12px] text-black/50">
                                                            @
                                                            {
                                                                cur?.account
                                                                    ?.userName
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (
                                                                cur &&
                                                                !cur.isFollow
                                                            ) {
                                                                dispatch(
                                                                    followUserRequest(
                                                                        {
                                                                            following:
                                                                                curUser._id,
                                                                        }
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                        className={`${
                                                            cur && !cur.isFollow
                                                                ? "bg-orange-color text-white px-2.5"
                                                                : "bg-white text-black-50 border border-black-10 px-3.5"
                                                        } py-[7px] text-sm font-medium rounded-lg capitalize flex items-center`}
                                                    >
                                                        {cur && !cur.isFollow
                                                            ? "Follow +"
                                                            : "Following"}
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                    <div className="px-4 border-t border-black-10 pb-1 flex justify-center mt-5 bg-white w-full">
                        <p className="text-sm font-medium text-black-30 pb-4">
                            &copy; 2022 Ulalive Inc
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Chat;
